import { createElementBlock as e, openBlock as o, createElementVNode as c } from "vue";
import r from "./index289.js";
const n = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function l(p, t, a, m, _, d) {
  return o(), e("svg", s, t[0] || (t[0] = [
    c("path", { d: "M48.529 39.003 34.742 14.537c-2.093-3.716-7.39-3.716-9.483 0L11.472 39.003c-2.07 3.672.548 8.247 4.742 8.247h27.573c4.193 0 6.81-4.575 4.742-8.247ZM30 23.467c.648 0 1.18.492 1.244 1.122l.006.128v6.827a1.25 1.25 0 0 1-2.493.127l-.007-.127v-6.827c0-.69.56-1.25 1.25-1.25ZM30 35.779l.147.006c.874.075 1.555.81 1.555 1.7 0 .938-.758 1.706-1.7 1.706-.943 0-1.7-.768-1.7-1.697a1.701 1.701 0 0 1 1.55-1.709l.148-.006Zm2.565-20.015L46.35 40.231c1.135 2.016-.297 4.519-2.564 4.519H16.214c-2.269 0-3.701-2.503-2.564-4.519l13.787-24.467a2.927 2.927 0 0 1 5.127 0Z" }, null, -1)
  ]));
}
const u = /* @__PURE__ */ r(n, [["render", l]]);
export {
  u as default
};
